export default __webpack_public_path__ + "static/media/ZA.26798a7d.svg";